import { Component, OnInit, Input } from "@angular/core";
import { DaoEventsService } from "src/app/providers/db/dao-events.service";
import { AlertController, NavController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Container } from "src/app/models/container";
import {
	trigger,
	transition,
	style,
	animate
} from '@angular/animations';

@Component({
	selector: "app-login-with-shortcode",
	templateUrl: "./login-with-shortcode.component.html",
	styleUrls: ["./login-with-shortcode.component.scss"],
	animations: [
		trigger('viewSlide', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateX(24px)' }),
				animate('250ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, transform: 'translateX(0)' }))
			]),
			transition(':leave', [
				animate('200ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 0, transform: 'translateX(-24px)' }))
			])
		])
	]
})
export class LoginWithShortcodeComponent implements OnInit {
	@Input() containerApp: Container;
	activeLoader: boolean = false;
	shortcode: string = null;
	msgShortcode: string = null;
	constructor(
		private daoEvent: DaoEventsService,
		private alertCtrl: AlertController,
		private translateService: TranslateService,
		private navCtrl: NavController
	) {}

	ngOnInit() {
		console.log("Shortcode !");
	}

	checkShortcode() {
		this.msgShortcode = null;
		// check shortcode input is filled
		if (
			this.shortcode !== "" &&
			this.shortcode !== null &&
			this.shortcode !== undefined
		) {
			this.shortcode = this.shortcode.toLowerCase();
			this.activeLoader = true;
			this.daoEvent.getEventByShortcode(this.shortcode, (event) => {
				if (event == null) {
					// case event doesn't exist
					this.msgShortcode = this.translateService.instant("global.alerts.event_shortcode_blank");
					this.shortcode = "";
					this.activeLoader = false;
				} else {
					this.navCtrl.navigateRoot([`/${this.shortcode}`]);
					this.shortcode = "";
					this.activeLoader = false;
				}
			});
		} else {
			// case blank, show error
			this.msgShortcode = this.translateService.instant("global.alerts.event_shortcode_blank");
			this.activeLoader = false;
		}
	}
}
